<template>
  <div class="nav-container">

        <router-link v-if="lang === 'fr'" class="logo-container" :to="{path: '/'}">
          <img src="./../assets/img/aer_small_black.svg" style="height: 37px;">
        </router-link>
        <router-link v-else-if="lang === 'en'" class="logo-container" :to="{path: '/en/'}">
          <img src="./../assets/img/aer_small_black.svg" style="height: 37px;">
        </router-link>


        <div class="lang-selector" v-if="menuLoaded">
          <div class="lang" v-if="lang === 'en'">
            <router-link :to="{path: $route.path.replace('/en/','/')}">FR</router-link>
          </div>
          <div class="lang selected" v-else>
            <span>FR</span>
          </div>
          <div class="lang" v-if="lang === 'fr'">
            <router-link :to="{path: '/en'+$route.path}">EN</router-link>
          </div>
          <div class="lang selected" v-else>
            <span>EN</span>
          </div>
        </div>


        <div class="toggle-menu m-only" @click="toggleMobileNav">
          <div id="nav-icon" :class="{ open: isMobileNavOpen }">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>

        <ul class="nav menu" :class="{ isOpen: isMobileNavOpen }">
            <div class="wrapper">


              <div class="nav-grid">

                <div class="grid-border"></div>
                <div class="grid-border d-only"></div>
                <div class="grid-border d-only"></div>
                <div class="grid-border d-only"></div>
              </div>
              <template v-if="this.isAuthenticated">
                <li class="item open" v-for="(item, itemIndex) in navigation">
                  <div class="spacer"></div>
                  <span v-if="lang === 'fr'">{{ item.title }}</span>
                  <span v-else-if="lang === 'en'">{{ item.title_en }}</span>
                  <div class="spacer" v-if="item.children"></div>
                  <ul class="submenu" v-if="item.children">
                      <li class="page" v-for="(subitem, subitemIndex) in item.children">
                        <template v-if="subitem.link_url">
                          <a :href="subitem.link_url" target="subitem.page_url">{{ subitem.title }}</a>
                          <!-- ÉDITER PAGE -->
                          <button class="btn circle mini" 
                            @click="showEditMenuItemModal('lien', item.name, item.title, subitem.name, subitem.title, subitem.url, subitem.link_url, itemIndex, subitemIndex)">
                            <i class="fa fa-pencil"></i>
                          </button>
                        </template>
                        <template v-else>
                          <router-link v-if="lang === 'fr' && subitem.title" @click.native="toggleMobileNav" :to="{path: subitem.url}">{{ subitem.title }}</router-link>
                          <router-link v-else-if="subitem.title_en && lang === 'en'" @click.native="toggleMobileNav" :to="{path: '/en'+subitem.url}">{{ subitem.title_en }}</router-link>
                          <!-- ÉDITER PAGE -->
                          <button class="btn circle mini" 
                            @click="showEditMenuItemModal('page', item.name, item.title, subitem.name, subitem.title, subitem.title_en, subitem.url, '', itemIndex, subitemIndex)">
                            <i class="fa fa-pencil"></i>
                          </button>
                        </template>
                        <!-- SUPPRIMER PAGE -->
                        <button class="btn circle mini" 
                          @click="showDeleteMenuItemModal(subitem.url)">
                          <i class="fa fa-trash"></i>
                        </button>
                      </li>
                  </ul>
                  <div class="add-buttons" style="width: 100%; text-align: left; margin-left:10px; margin-top:10px">
                    <button @click="showCreateMenuItemModal('page', item.name, item.title, item.title_en)" class="btn normal">
                      <i class="fa fa-plus"></i>&nbsp;Page
                    </button>
                    <button @click="showCreateMenuItemModal('lien', item.name, item.title)" class="btn normal">
                      <i class="fa fa-plus"></i>&nbsp;Lien
                    </button>
                  </div>

                  <div class="spacer"></div>
                  <div class="spacer"></div>
                  <div class="spacer d-only"></div>

                </li>
              
              </template>
              <template v-else>
                <li class="item open" v-for="(item, itemIndex) in navigation">
                  <div class="spacer"></div>
                  <span v-if="lang === 'fr'">{{ item.title }}</span>
                  <span v-else-if="lang === 'en'">{{ item.title_en }}</span>
                  <div class="spacer" v-if="item.children"></div>
                  <ul class="submenu" v-if="item.children">
                      <li class="page" v-for="(subitem, subitemIndex) in item.children">
                        <template v-if="subitem.link_url">
                          <a :href="subitem.link_url" target="subitem.page_url">{{ subitem.title }}</a>
                        </template>
                        <template v-else>
                          <router-link v-if="lang === 'fr' && subitem.title" @click.native="toggleMobileNav" :to="{path: subitem.url}">{{ subitem.title }}</router-link>
                          <router-link v-else-if="subitem.title_en && lang === 'en'" @click.native="toggleMobileNav" :to="{path: '/en'+subitem.url}">{{ subitem.title_en }}</router-link>
                        </template>
                      </li>
                  </ul>
                  <div class="spacer"></div>
                  <div class="spacer"></div>
                  <div class="spacer d-only"></div>

                </li>
                <li class="item open m-only" v-if="membres">
                  <div class="spacer"></div>
                  <span>Membres</span>
                  <div class="spacer"></div>
                  <ul class="submenu">
                      <li class="page" v-for="subitem in membres">
                  <router-link @click.native="toggleMobileNav" v-if="lang === 'fr' " :to="{path: subitem.url}">
                      {{subitem.title}}
                  </router-link>
                  <router-link @click.native="toggleMobileNav" v-else-if="lang === 'en' " :to="{path: '/en'+subitem.url}">
                      {{subitem.title}}
                  </router-link>


                      </li>
                  </ul>
                  <div class="spacer"></div>
                  <div class="spacer"></div>
                  <div class="spacer d-only"></div>

                </li>  

              </template>

            </div>
        </ul>

                <!--  CREATE MODAL-->                
                <Modal :show="createMenuItemModal.show" @close="createMenuItemModal.show = false">
                  <template v-if="createMenuItemModal.type == 'page'">
                    <div class="modal-header">
                        <h3>Ajouter une page dans “{{ createMenuItemModal.parentTitle }}”</h3>
                    </div>
                    <div class="modal-body">
                        <label class="form-label">
                          <input autofocus v-model="createMenuItemModal.title" class="form-control" placeholder="Entrer un nom (français)">
                          <input autofocus v-model="createMenuItemModal.title_en" class="form-control" placeholder="Entrer un nom (anglais)">
                        </label>
                    </div>
                    <div class="modal-footer text-right">
                        <button class="btn normal" @click="createMenuItemModal.show = false">Annuler</button>
                        <button class="btn normal" @click="createMenuItem('page')">Ajouter</button>
                    </div>
                  </template>
                  <template v-else-if="createMenuItemModal.type == 'lien'">
                    <div class="modal-header">
                        <h3>Ajouter un lien dans “{{ createMenuItemModal.parentTitle }}”</h3>
                    </div>
                    <div class="modal-body">
                        <label class="form-label">
                          <input v-model="createMenuItemModal.title" class="form-control" placeholder="Entrer un nom (français)">
                          <input v-model="createMenuItemModal.link_url" class="form-control" placeholder="Entrer l’url cible (http://www.example.com)">
                        </label>
                    </div>
                    <div class="modal-footer text-right">
                        <button class="btn normal" @click="createMenuItemModal.show = false">Annuler</button>
                        <button class="btn normal" @click="createMenuItem('lien')">Ajouter</button>
                    </div>
                  </template>
                </Modal>

                <!--  EDIT MODAL-->                
                <Modal :show="editMenuItemModal.show" @close="editMenuItemModal.show = false">
                  <template v-if="editMenuItemModal.type == 'page'">
                    <div class="modal-header">
                      <h3>Modifier le lien</h3>
                    </div>
                    <div class="modal-body">
                        <label class="form-label">
                          <input autofocus v-model="editMenuItemModal.title" class="form-control" placeholder="Entrer un nom (français)">
                          <input autofocus v-model="editMenuItemModal.title_en" class="form-control" placeholder="Entrer un nom (anglais)">
                        </label>
                    </div>
                    <div class="modal-footer text-right">
                        <button class="btn normal" @click="editMenuItemModal.show = false">Annuler</button>
                        <button class="btn normal" @click="editMenuItem('page')">Modifier</button>
                    </div>
                  </template>
                  <template v-else-if="editMenuItemModal.type == 'lien'">
                    <div class="modal-header">
                        <h3>Modifier le lien</h3>
                    </div>
                    <div class="modal-body">
                        <label class="form-label">
                          <input autofocus v-model="editMenuItemModal.title" class="form-control" placeholder="Entrer un nom">
                          <input autofocus v-model="editMenuItemModal.link_url" class="form-control" placeholder="Entrer l’url cible (http://www.example.com)">
                        </label>
                    </div>
                    <div class="modal-footer text-right">
                        <button class="btn normal" @click="editMenuItemModal.show = false">Annuler</button>
                        <button class="btn normal" @click="editMenuItem('lien')">Modifier</button>
                    </div>
                  </template>
                </Modal>

                <!--  DELETE MODAL-->  
                <Modal :show="deleteMenuItemModal.show" @close="deleteMenuItemModal.show = false">
                  <div>
                    <div class="modal-header">
                        <h3>Supprimer la page ?</h3>
                    </div>
                    <div class="modal-footer text-left">
                        <button class="btn normal" @click="deleteMenuItemModal.show = false">Annuler</button>
                        <button class="btn normal" @click="deleteMenuItem()">OK</button>
                    </div>
                  </div>
                </Modal>
  </div>
</template>

<script>

import axios from 'axios'
import { mapGetters } from 'vuex'
import Modal from './UI/Modal'

export default {
  name: 'Navigation',
  components: {
    Modal
  },
  props: ['lang'],
  computed: {
    ...mapGetters([
      'isAuthenticated',
      'userAuthenticated'
    ]),
    membres() {
      if (this.sideNavigation[0]){
        return this.sideNavigation[0].children
      }
    }
  },
  data () {
    return {
      menuLoaded: false,
      createMenuItemModal: {
        show: false,
        type: '',
        title: '',
        title_en: '',
        link_url: '',
        parentTitle: '',
        parentName: ''
      },
      editMenuItemModal: {
        show: false,
        type: '',
        name: '',
        title: '',
        title_en: '',
        url: '',
        parentTitle: '',
        parentName: '',
        link_url: '',
        itemIndex: 0,
        subitemIndex: 0,
      },
      deleteMenuItemModal: {
        show: false,
        url: ''
      },
      content: '',
      navigation: [],
      sideNavigation: [],
      isMobileNavOpen: false
    }
  },
  methods: {
    getNavigation () {
      var sections = ['arts-en-residence', 'outils', 'projets']
      var promises = []
      sections.forEach(function (singleElement) {
        promises.push(axios.get('/api/page/' + singleElement + '?getChildren'))
      })
      axios.all(promises).then(function (results) {
        this.navigation = []
        this.menuLoaded = true
        results.forEach(function (response) {
          console.log(response.data)
          this.navigation.push(response.data)
        }.bind(this))
      }.bind(this))

    },
    getSideNavigation () {
      axios.get('/api/page/membres?getChildren').then(response => {
        this.sideNavigation = []
        this.sideNavigation.push(response.data)
      })
      .catch(error => {
        console.log(error)
      })
    },
    showCreateMenuItemModal (type, parentName, parentTitle) {
      this.createMenuItemModal.show = true
      this.createMenuItemModal.type = type
      this.createMenuItemModal.parentName = parentName
      this.createMenuItemModal.parentTitle = parentTitle
    },
    showEditMenuItemModal (type, parentName, parentTitle, name, title, title_en, url, link_url, itemIndex, subitemIndex) {
      this.editMenuItemModal.show = true
      this.editMenuItemModal.type = type
      this.editMenuItemModal.parentName = parentName
      this.editMenuItemModal.parentTitle = parentTitle
      this.editMenuItemModal.title = title
      this.editMenuItemModal.title_en = title_en
      this.editMenuItemModal.name = name
      this.editMenuItemModal.url = url
      this.editMenuItemModal.link_url = link_url
      this.editMenuItemModal.itemIndex = itemIndex
      this.editMenuItemModal.subitemIndex = subitemIndex
    },
    showDeleteMenuItemModal (url) {
      this.deleteMenuItemModal.show = true
      this.deleteMenuItemModal.url = url
    },
    createMenuItem (type) {
      var params = {}
      if (type === 'page') {
        params = {pageTitle: this.createMenuItemModal.title, pageTitleEn: this.createMenuItemModal.title_en}
      } else if (type === 'lien') {
        params = {
          pageTitle: this.createMenuItemModal.title, 
          link_url: this.createMenuItemModal.link_url
        }
      }
      axios.post('/api/page/' + this.createMenuItemModal.parentName, params).then(response => {
        this.$notify({title: 'La page a été créé'})
        this.getNavigation()
        this.createMenuItemModal.title = ''
        this.createMenuItemModal.title_en = ''
        this.createMenuItemModal.link_url = ''
        this.createMenuItemModal.show = false
      })
      .catch(error => {
        this.$notify({title: 'Erreur', text: error.data})
      })
    },
    editMenuItem (type) {
      var params = {}
      if (type === 'page') {
        params = { pageTitle: this.editMenuItemModal.title, pageTitleEn: this.editMenuItemModal.title_en }
        setTimeout( function(){
          app.$router.push(this.navigation[this.editMenuItemModal.itemIndex].children[this.editMenuItemModal.subitemIndex].url)
        }.bind(this), 2500)

      } else if (type === 'lien') {
        params = {
          pageTitle: this.editMenuItemModal.title, 
          link_url: this.editMenuItemModal.link_url
        }
      }
      axios.put('/api/page' + this.editMenuItemModal.url, params).then(response => {
        this.$notify({title: 'La page a été modifiée'})
        this.getNavigation()
        this.editMenuItemModal.show = false
      })
      .catch(error => {
        this.$notify({title: 'Erreur', text: error.data})
      })
    },
    deleteMenuItem () {
      axios.delete('/api/page/' + this.deleteMenuItemModal.url).then((response) => {
        this.$notify({title: 'La page a été supprimé'})
        this.getNavigation()
        this.deleteMenuItemModal.show = false
      })
      .catch(error => {
        this.$notify({title: 'Erreur', text: error.data})
      })
    },
    toggleMobileNav () {
      if (global.isMobile){
        this.isMobileNavOpen = !this.isMobileNavOpen
      }
    }
  },
  created () {
    this.getNavigation()
    this.getSideNavigation()
    this.lang = global.lang
    
    if (app.$route.path.split('/')[1] == 'en'){
      global.lang = 'en'
    }else{
      global.lang = 'fr'
    }
    this.lang = global.lang

  },
  watch: {
    mapIsReady (val) {
      console.log(val)
    },
    $route () {
      if (app.$route.path.split('/')[1] == 'en'){
        global.lang = 'en'
        this.getNavigation()
        this.getSideNavigation()
      }else{
        global.lang = 'fr'
        this.getNavigation()
        this.getSideNavigation()       
      }
      this.lang = global.lang
    }

  }
}
</script>

<style>
  li.item .add-buttons{
    display: none;
  }

  li.item:hover .add-buttons{
    display: block;
  }

  li.page .btn{
    display: none;
  }

  li.page:hover .btn{
    display: inline;
  }

  .nav-container{
    position: relative;
  }

  .lang-selector{
    position: absolute;
    bottom: 0px;
    width: 60px;
    border-top: 1px solid black;
    font-size:0.8em;
    z-index: 999;
  }

  .lang{
    width: 50%;
    float: left;
    text-align: center;
    display: block;
  }

  .lang.selected{
    background-color: black;
    color:white;
  }



  .lang a:hover:before{
    content: none;
  }

</style>


// WEBPACK FOOTER //
// src/components/Navigation.vue